// import React, { useState, useEffect } from "react";

// const PacificProjects = () => {
//   const images = [
//     {
//       image: "/images/Profile.jpg",
//       content: "Dar-ul-Shifa Hospital",
//       description:
//         "Construction of a three story hospital including basement with finishes, electrical, mechanical and HVAC work.",
//     },
//     {
//       image: "/images/Picture31.jpg",
//       content: "Commercial Building 3-Tariq Block.",
//       description:
//         "Structural, electrical, mechanical, finishing, elevators etc.",
//     },
//     {
//       image: "/images/Picture10.jpg",
//       content: "M.A. Jinnah Mosque Bahria Orchard-2, Lahore.",
//       description: "Grey Structural works.",
//     },
//     {
//       image: "/images/Profile3.jpg",
//       content: "Bahria Orchard-4 School, Lahore.",
//       description: "Structural works.",
//     },
//     {
//       image: "/images/Profile4.jpg",
//       content: "Union Tower Sialkot",
//       description: "Structural works.",
//     },
//     {
//       image: "/images/Profile5.jpg",
//       content: "Boulevard Heights, Lahore",
//       description: "Civil and finishing works",
//     },
//     {
//       image: "/images/Profile6.jpg",
//       content: "Sitara Sapna City, Faisalabad",
//       description:
//         "Construction of 100 houses of 10 marla, 15 marla and 1 kanal.",
//     },
//     {
//       image: "/images/Profile7.jpg",
//       content: "City Center Multan",
//       description:
//         "Construction of a high rise mall, subcontract by United Engineers (Pvt) Ltd.",
//     },
//     {
//       image: "/images/Profile8.jpg",
//       content: "Residential villas",
//       description: "Luxury Villa in DHA EME, Lahore.",
//     },
//     {
//       image: "/images/Picture18.jpg",
//       content: "Five Star Textiles",
//       description: "Steel construction with RCC foundation.",
//     },
//     {
//       image: "/images/Picture33.jpg",
//       content: "Variant Apartment Building at Plot No. 29, Gulberg III",
//       description: "Structural works",
//     },
//     {
//       image: "/images/Picture32.jpg",
//       content: "Masjid Al Hussain Bahria Town, Lahore.",
//       description: "Grey Structural works.",
//     },
//   ];

//   const [startIndex, setStartIndex] = useState(0);

//   const handlePrev = () => {
//     setStartIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const handleNext = () => {
//     setStartIndex((prev) => (prev + 1) % images.length);
//   };

//   // Auto-slide logic
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setStartIndex((prev) => (prev + 1) % images.length);
//     }, 3000); // Slide every 3 seconds

//     return () => clearInterval(interval); // Clean up
//   }, [images.length]);

//   const visibleImages = [
//     images[startIndex],
//     images[(startIndex + 1) % images.length],
//     images[(startIndex + 2) % images.length],
//   ];

//   return (
//     <div className="bg-white px-8 py-12 font-sans w-full lg:w-[90%] mx-auto">
//       <h2 className="text-3xl font-bold text-black mb-2">
//         PACIFIC BUILDERS (PVT) LTD
//       </h2>
//       <h3 className="text-2xl font-semibold text-gray-800 mb-4">
//         Trusted Construction Services Across Pakistan
//       </h3>
//       <p className="text-gray-700 text-base leading-relaxed mb-8">
//         <span className="text-blue-600 font-bold">
//           PACIFIC BUILDERS (PVT) LTD
//         </span>{" "}
//         is one of Pakistan’s leading construction companies, offering
//         high-quality services in all types of terrains across the country. With
//         successful completion of numerous projects including{" "}
//         <span className="text-blue-600 font-medium">
//           high-rise buildings, Mosques, hospitals, educational institutions, and
//           Residential villas
//         </span>
//         , we take pride in delivering unmatched quality, safety, and timely
//         delivery at competitive prices.
//       </p>

//       {/* Image Gallery */}
//       <div className="relative">
//         <div className="flex gap-4">
//           {visibleImages.map((img, index) => (
//             <div key={index} className="w-1/3">
//               <img
//                 src={img.image}
//                 alt={`Slide ${index + 1}`}
//                 className="w-full h-64 object-cover rounded shadow-md"
//               />
//               {img.content && (
//                 <p className="text-sm text-center text-gray-600 mt-2">
//                   {img.content}
//                 </p>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Navigation Arrows */}
//         <button
//           onClick={handlePrev}
//           className="absolute -left-6 top-1/2 transform -translate-y-1/2 bg-gradient-to-b from-[#1BB095] to-teal-900 text-white rounded-full p-3 hover:bg-orange-700 transition"
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>

//         <button
//           onClick={handleNext}
//           className="absolute -right-6 top-1/2 transform -translate-y-1/2 bg-gradient-to-b from-[#1BB095] to-teal-900 text-white rounded-full p-3 hover:bg-orange-700 transition"
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PacificProjects;


import React, { useState, useEffect } from "react";

const PacificProjects = () => {
  const images = [
    {
      image: "/images/Profile.jpg",
      content: "Dar-ul-Shifa Hospital",
      description:
        "Construction of a three story hospital including basement with finishes, electrical, mechanical and HVAC work.",
    },
    {
      image: "/images/Picture31.jpg",
      content: "Commercial Building 3-Tariq Block.",
      description:
        "Structural, electrical, mechanical, finishing, elevators etc.",
    },
    {
      image: "/images/Picture10.jpg",
      content: "M.A. Jinnah Mosque Bahria Orchard-2, Lahore.",
      description: "Grey Structural works.",
    },
    {
      image: "/images/Profile3.jpg",
      content: "Bahria Orchard-4 School, Lahore.",
      description: "Structural works.",
    },
    {
      image: "/images/Profile4.jpg",
      content: "Union Tower Sialkot",
      description: "Structural works.",
    },
    {
      image: "/images/Profile5.jpg",
      content: "Boulevard Heights, Lahore",
      description: "Civil and finishing works",
    },
    {
      image: "/images/Profile6.jpg",
      content: "Sitara Sapna City, Faisalabad",
      description:
        "Construction of 100 houses of 10 marla, 15 marla and 1 kanal.",
    },
    {
      image: "/images/Profile7.jpg",
      content: "City Center Multan",
      description:
        "Construction of a high rise mall, subcontract by United Engineers (Pvt) Ltd.",
    },
    {
      image: "/images/Profile8.jpg",
      content: "Residential villas",
      description: "Luxury Villa in DHA EME, Lahore.",
    },
    {
      image: "/images/Picture18.jpg",
      content: "Five Star Textiles",
      description: "Steel construction with RCC foundation.",
    },
    {
      image: "/images/Picture33.jpg",
      content: "Variant Apartment Building at Plot No. 29, Gulberg III",
      description: "Structural works",
    },
    {
      image: "/images/Picture32.jpg",
      content: "Masjid Al Hussain Bahria Town, Lahore.",
      description: "Grey Structural works.",
    },

    {
      image: "/images/mainaura.jpeg",
      content: "Aura Tower 3G Gulberg 2 Lahore",
      description: "Grey Structural works.",
    },
  ];

  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => {
    setStartIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % images.length);
  };

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  // Dynamically adjust visible images based on screen size
  const getVisibleImages = () => {
    if (window.innerWidth < 640) return 1; // mobile
    if (window.innerWidth < 1024) return 2; // tablet
    return 3; // desktop
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleImages());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleImages());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const visibleImages = images.slice(startIndex, startIndex + visibleCount);

  return (
    <div className="bg-white px-4 sm:px-6 md:px-8 py-12 font-sans w-full lg:w-[90%] mx-auto">
      <h2 className="text-3xl font-bold text-black mb-2">
        PACIFIC BUILDERS (PVT) LTD
      </h2>
      <h3 className="text-2xl font-semibold text-gray-800 mb-4">
        Trusted Construction Services Across Pakistan
      </h3>
      <p className="text-gray-700 text-base leading-relaxed mb-8">
        <span className="text-blue-600 font-bold">
          PACIFIC BUILDERS (PVT) LTD
        </span>{" "}
        is one of Pakistan’s leading construction companies, offering
        high-quality services in all types of terrains across the country. With
        successful completion of numerous projects including{" "}
        <span className="text-blue-600 font-medium">
          high-rise buildings, Mosques, hospitals, educational institutions, and
          Residential villas
        </span>
        , we take pride in delivering unmatched quality, safety, and timely
        delivery at competitive prices.
      </p>

      {/* Image Gallery */}
      <div className="relative">
        <div className={`grid gap-4 
          ${visibleCount === 1 ? "grid-cols-1" : ""}
          ${visibleCount === 2 ? "grid-cols-2" : ""}
          ${visibleCount === 3 ? "grid-cols-3" : ""}`}>
          {visibleImages.map((img, index) => (
            <div key={index}>
              <img
                src={img.image}
                alt={`Slide ${index + 1}`}
                className="w-full h-64 object-cover rounded shadow-md"
              />
              {img.content && (
                <p className="text-sm font-semibold text-center text-gray-800 mt-2">
                  {img.content}
                </p>
              )}
              {img.description && (
                <p className="text-xs text-center text-gray-600 px-2 mt-1">
                  {img.description}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          onClick={handlePrev}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gradient-to-b from-[#1BB095] to-teal-900 text-white rounded-full p-2 sm:p-3 hover:bg-orange-700 transition z-10"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={handleNext}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gradient-to-b from-[#1BB095] to-teal-900 text-white rounded-full p-2 sm:p-3 hover:bg-orange-700 transition z-10"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PacificProjects;
